// The Stripe Checkout Session url in a klap-api checkout response
// (POST /billing/subscription, POST /billing/credits), or null when the
// response carries none. Pages redirect to it directly: Stripe.js removed
// redirectToCheckout in its Clover release (only the legacy v3 script,
// Acacia and Basil still have it).
export const readCheckoutUrl = (body: unknown): string | null => {
  const url = (body as { checkout_url?: unknown } | null)?.checkout_url;
  return typeof url === "string" && url.length > 0 ? url : null;
};
